import React, { useEffect, useState } from "react";
import Header from '../../common/Header'
import Sidebar from '../../common/Sidebar'
import Footer from '../../common/Footer'
import PageHeader from '../../pages/PageHeader'
import axios from "axios";
import { triggerAlert, ConfirmationAlert } from '../../utils';
import Loader from '../../common/Loader'

import DataTable from 'react-data-table-component';
import { Modal, ModalBody } from "react-bootstrap";
import { set, useForm, } from 'react-hook-form';
import { Menu, MenuItem, Select, OutlinedInput, Chip, FormControl, InputLabel, Checkbox, ListItemText } from "@mui/material";
import moment from "moment-timezone";
import { FaEyeSlash } from "react-icons/fa";
import Cookies from 'js-cookie';
import dayjs from "dayjs";
export default function Promocodes() {
    document.title = "SmartInvestorDeck - Promocodes"
    const mainHeading = "Promocodes";
    const heading = "Settings / Promocodes";
    const { register: registerForm, handleSubmit: handleSubmitForm, formState: { errors: errorsForm }, setValue: setValueForm, reset: resetForm, clearErrors, setError, trigger } = useForm();
    const [isEditing, setIsEditing] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [Data, setData] = useState([]);
    const [Createrole, setCreaterole] = useState(false);
    const [message, setMessage] = useState("Create");
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState('')
    const [edit, isedit] = useState(false)
    const [SelectedId, setSelectedId] = useState("")
    const [plans, setPlans] = useState([])
    const [selectedPlans, setSelectedPlans] = useState([])
    console.log(SelectedId, 'seuihuiwhduih');

    useEffect(() => {
        fetchPlans()
    }, [])

    const fetchPlans = async () => {

        const res = await axios.get(`apiV1/add-subscription-plan/`)

        if (res.status === 200) {
            setPlans(res.data.results)
        }
    }

    console.log(plans, 'plans');

    const fetchListData = async (page, size = perPage, searchkey) => {
        setIsLoading(true);
        try {
            // let token = sessionStorage.getItem("admin_user_token")
            let token = Cookies.get("admin_user_token");
            const response = await axios.get(`apiV1/promo-codes/?page_number=${page}&page_size=${size}`,
                // {
                //     headers: {
                //         'Authorization': ` ${token}`,
                //         'Content-Type': 'application/json'
                //     }
                // }
            );
            const response_data = response.data
            if (response.status === 200) {
                setIsLoading(false);
                setIsEditing(false)
                setTotalRows(response_data.count)
                const itemsArray = response_data;
                itemsArray.map((item, i) => {
                    item.Num = i + 1;
                    return item
                })
                setData(response_data);
                setValueForm("per_resume_cost", response_data.results[0].per_resume_cost)
                setValueForm("per_test_cost", response_data.results[0].per_test_cost)
                setValueForm("per_user_cost", response_data.results[0].per_user_cost)
                setValueForm("per_agent_cost", response_data.results[0].per_agent_cost)
                setValueForm("per_call_cost", response_data.results[0].per_call_cost)
                setValueForm("per_minute_call_duration_cost", response_data.results[0].per_minute_call_duration_cost)
            } else if (response.status === 204) {
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
            }

        } catch (error) {
            setIsLoading(false);
        }
    };

    const columns = [
        {
            name: 'S.No',
            selector: row => row.Num,
            sortable: true,
            center: true,
            width: "100px"
        },
        {
            name: 'Coupon Code',
            selector: row => row.code,
            sortable: true,
            center: true,
        },
        {
            name: 'Discount Percentage',
            selector: row => row.discount_value,
            sortable: true,
            center: true,
        },
        {
            name: 'Maximum Uses',
            selector: row => row.max_uses,
            sortable: true,
            center: true,
        },
        {
            name: 'Validity Days',
            selector: row => row.validity_days,
            sortable: true,
            center: true,
        },
        {
            name: 'Created At',
            selector: row => row.created_at,
            cell: row => (
                <>
                    {dayjs(row.created_at).format('MM-DD-YYYY')}
                </>
            ),
            sortable: true,
        },
         {
            name: 'Created by',
            selector: row => row.created_by_username,
            sortable: true,
        },
        {
            name: 'Updated At',
            selector: row => row.updated_at,
            cell: row => (
                <>
                    {moment(row.updated_at).format('MM-DD-YYYY')}
                </>
            ),
            sortable: true,
        },
         {
            name: 'Updated by',
            selector: row => row.updated_by_username,
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <div className="d-flex gap-2">
                    <span className="btn btn-success activebtn btn-sm btn-rounded waves-effect waves-light" onClick={() => { setMessage("Edit"); setCreaterole(true); onloadedmetadata(row); isedit(true) }}>Edit</span>
                    {customerdelete && (
                        <span className="btn btn-danger Inactivebtn btn-sm btn-rounded waves-effect waves-light"
                            onClick={() => ChangeStatus(row.id, row.is_active ? false : true)}>
                            {row.is_active ? "Deactivate" : "Activate"}
                        </span>
                    )}
                </div>
            ),
        }
    ]

    const onSubmit = async (data) => {
        let req =
        {
            code: data.code,
            discount_value: data.discount,
            validity_days: data.validityDays,
            max_uses: data.maximumUsers,
            description: data.description || "",
            applicable_plans: selectedPlans,
        }
        if (edit) {
            try {

                const response = await axios.patch(`/apiV1/promo-codes/${SelectedId}/`, req)
                if (response.status === 200) {
                    triggerAlert('success', 'success', 'Code updated Successfully!!');
                    setSelectedPlans([])
                    resetForm()
                    setCreaterole(false)
                    isedit(false)
                    fetchListData(1)
                }
            } catch (err) {
                console.log(err?.response?.data?.message);

            }
        }
        else {

            try {
                const response = await axios.post('/apiV1/promo-codes/', req)
                if (response.status === 200 || response.status === 201) {
                    triggerAlert('success', 'success', 'Code Added Successfully!!');
                    setSelectedPlans([])
                    resetForm()
                    setCreaterole(false)
                    fetchListData(1)
                }
            } catch (err) {
                console.log(err?.response?.data?.message);

            }
        }
    };
    const access_privileges = JSON.parse(Cookies.get("modulepermissions"))
    const [customerlist, setcustomerlist] = useState(false)
    const [customeradd, setcustomeradd] = useState(false)
    const [customeredit, setcustomeredit] = useState(false)
    const [customerdelete, setcustomerdelete] = useState(false)
    useEffect(() => {
        fetchListData(1);
        access_privileges.map((access, i) => {
            access.sub_module_info.map((subaccess, k) => {
                if (subaccess.name == "Config" && subaccess.permissions.indexOf(1) !== -1) {
                    setcustomerlist(true)
                }
                if (subaccess.name == "Config" && subaccess.permissions.indexOf(2) !== -1) {
                    setcustomeradd(true)
                }
                if (subaccess.name == "Config" && subaccess.permissions.indexOf(3) !== -1) {
                    setcustomeredit(true)
                }
                if (subaccess.name == "Config" && subaccess.permissions.indexOf(4) !== -1) {
                    setcustomerdelete(true)
                }

            })


        })
    }, []);
    const handlecloseedit = () => {
        setIsEditing(false)
        clearErrors("per_user_cost")
        clearErrors("per_test_cost")
        clearErrors("per_resume_cost")
    }

    const handleModalClose = () => {
        setCreaterole(false)
        setSelectedPlans([])
        resetForm()
        isedit(false)
        setSelectedId("")
    }
    const validateNumber = (e) => {
        const { name, value } = e.target;
        if (value === '') {
            setError(name, {
                type: 'manual',
                message: `${name} is required`,
            });
        } else if (/^\d*$/.test(value)) {
            clearErrors(name);
        } else {
            setError(name, {
                type: 'manual',
                message: 'Please enter only numbers',
            });
        }
    };
    const onloadedmetadata = (data) => {
        console.log(data, 'gfshgadaf');

        setSelectedId(data.id)
        setValueForm("noOfProjects", data?.project_count)
        setValueForm("price", data?.price)
        setValueForm("description", data?.description)
        setValueForm("code", data?.code)
        setValueForm("discount", data?.discount_value)
        setValueForm("validityDays", data?.validity_days)
        setValueForm("maximumUsers", data?.max_uses)
        setSelectedPlans(data?.applicable_plans || [])
    }
    const handlePageChange = page => {
        fetchListData(page, perPage,);
        setCurrentPage(page);
    };
    const handlePerRowsChange = async (newPerPage, page) => {
        fetchListData(page, newPerPage);
        setPerPage(newPerPage);
        setCurrentPage(page);
    };
    const ChangeStatus = async (data, isActive) => {
        console.log(data, isActive, 'datayy');

        let req =
        {
            is_active: isActive
        }
        try {
            const response = await axios.patch(`/apiV1/promo-codes/${data}/`, req)
            if (response.status === 200) {
                fetchListData(1)
                triggerAlert('success', 'success', 'Status updated Successfully!!');

            }
        } catch (err) {
            console.log(err?.data?.reponse?.message);

        }
    }
    return (
        <>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">

                            {/* start page title */}
                            <PageHeader mainHeading={mainHeading} heading={heading} />
                            {/* end page title */}
                            <>
                                <div className="btn-group float-end col-md-1  ml-10 mb-3">
                                    {customeradd && <button type="button" className="btn btn-primary w-md btn-md  " onClick={() => { setSelectedPlans([]); setCreaterole(true); setMessage('Create'); resetForm(); isedit(false) }} style={{ "marginLeft": "10px" }}>
                                        Create Coupon
                                    </button>}
                                </div>
                                {/* <div className="row">
                                    <form onSubmit={handleSubmitForm(onSubmit)}>
                                        <div className="d-flex justify-content-end mb-3">
                                            {!isEditing && (
                                                <button className="btn btn-dark radius-md rounded-circle" onClick={() => setIsEditing(true)}>
                                                    <i className="bx bx-edit" style={{ fontSize: "20px", marginTop: "3px" }}></i>
                                                </button>
                                            )}
                                        </div>

                                        <div className="row">
                                            <div className="form-group col-md-3 mb-3">
                                                <div className="mb-3">
                                                    <label htmlFor="per_user_cost" className="form-label">
                                                        Per User Cost(USD)<span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        {...registerForm('per_user_cost', {
                                                            required: 'Per User Cost is required',
                                                            pattern: {
                                                                value: /^\d+(\.\d{1,2})?$/, 
                                                                message: 'Please enter a valid number',
                                                            },
                                                        })}
                                                        name="per_user_cost"
                                                        disabled={!isEditing}
                                                        onKeyUp={() => {
                                                            trigger("per_user_cost");
                                                        }}
                                                    />
                                                    {errorsForm.per_user_cost && (
                                                        <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                                                            {errorsForm.per_user_cost.message}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-group col-md-3 ms-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Test Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_test_cost', {
                                                        required: 'Per Test Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/, 
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_test_cost"
                                                    disabled={!isEditing}
                                                    onKeyUp={() => {
                                                        trigger("per_test_cost");
                                                    }}
                                                />
                                                {errorsForm.per_test_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_test_cost.message}</div>
                                                )}
                                            </div>

                                            <div className="form-group col-md-3 ms-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Resume Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_resume_cost', {
                                                        required: 'Per Resume Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_resume_cost"
                                                    disabled={!isEditing} 
                                                    onKeyUp={() => {
                                                        trigger("per_resume_cost");
                                                    }}
                                                />
                                                {errorsForm.per_resume_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_resume_cost.message}</div>
                                                )}
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Agent Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_agent_cost', {
                                                        required: 'Per Resume Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_agent_cost"
                                                    disabled={!isEditing} 
                                                    onKeyUp={() => {
                                                        trigger("per_agent_cost");
                                                    }}
                                                />
                                                {errorsForm.per_agent_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_agent_cost.message}</div>
                                                )}
                                            </div>
                                            <div className="form-group col-md-3 ms-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Call Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_call_cost', {
                                                        required: 'Per Resume Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_call_cost"
                                                    disabled={!isEditing} 
                                                    onKeyUp={() => {
                                                        trigger("per_call_cost");
                                                    }}
                                                />
                                                {errorsForm.per_call_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_call_cost.message}</div>
                                                )}
                                            </div>
                                            <div className="form-group col-md-3 ms-3">
                                                <label htmlFor="formrow-email-input" className="form-label">
                                                    Per Minute Call Duration Cost(USD) <span className="text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control"
                                                    {...registerForm('per_minute_call_duration_cost', {
                                                        required: 'Per Resume Cost is required',
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: 'Please enter only numbers',
                                                        }
                                                    })}
                                                    name="per_minute_call_duration_cost"
                                                    disabled={!isEditing} 
                                                    onKeyUp={() => {
                                                        trigger("per_resume_cost");
                                                    }}
                                                />
                                                {errorsForm.per_minute_call_duration_cost && (
                                                    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.per_minute_call_duration_cost.message}</div>
                                                )}
                                            </div>
                                        </div>
                                        {isEditing && (
                                            <div className="py-2 mt-3">
                                                <div className="row">
                                                    <div className="col-12 text-end">
                                                        <button className='btn btn-warning w-md btn-md me-2' type="button" onClick={() => { handlecloseedit(); fetchListData(1); }}>Cancel</button>
                                                        <button className='btn btn-primary w-md btn-md' type="submit" disabled={!isEditing} >Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </form>
                                </div> */}
                                <DataTable
                                    columns={columns}
                                    data={Data}
                                    pagination
                                    paginationServer
                                    fixedHeaderScrollHeight='600px'
                                    fixedHeader
                                    persistTableHead
                                    paginationTotalRows={totalRows}
                                    // paginationPerPage={perPage}
                                    // paginationComponentOptions={paginationComponentOptions}
                                    // paginationDefaultPage={currentPage}

                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                />
                            </>

                            <Modal size='md' show={Createrole} onHide={handleModalClose} className='  modal fade ' backdrop="static" keyboard={false} >
                                <Modal.Header className='modal-header_box bg-my-primary p-3 d-flex justify-content-between ' closeButton> <h1 className="modal-title fs-5 ">{message} Coupon  </h1> </Modal.Header>
                                <form onSubmit={handleSubmitForm(onSubmit)}>
                                    <ModalBody>

                                        {/* Row 1: Coupon Code + Discount Percentage */}
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Coupon Code <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("code", {
                                                        required: "Coupon Code is required",
                                                        pattern: {
                                                            value: /^[A-Za-z0-9]*$/,
                                                            message: "Please enter a valid Coupon Code",
                                                        },
                                                    })}
                                                    onKeyUp={() => trigger("code")}
                                                />
                                                {errorsForm.code && (
                                                    <div className="text-danger mt-1">{errorsForm.code.message}</div>
                                                )}
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Discount Percentage <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("discount", {
                                                        required: "Discount Percentage is required",
                                                        pattern: {
                                                            value: /^\d+(\.\d{1,2})?$/,
                                                            message: "Please enter a valid discount",
                                                        },
                                                    })}
                                                    onKeyUp={() => trigger("discount")}
                                                />
                                                {errorsForm.discount && (
                                                    <div className="text-danger mt-1">{errorsForm.discount.message}</div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Row 2: Validity Days + Maximum Users */}
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Validity Days <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("validityDays", {
                                                        required: "Validity Days is required",
                                                        pattern: {
                                                            value: /^[0-9]*$/,
                                                            message: "Please enter a valid Validity Days",
                                                        },
                                                    })}
                                                    onKeyUp={() => trigger("validityDays")}
                                                />
                                                {errorsForm.validityDays && (
                                                    <div className="text-danger mt-1">
                                                        {errorsForm.validityDays.message}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Maximum Users <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("maximumUsers", {
                                                        required: "Maximum Users is required",
                                                        pattern: {
                                                            value: /^[0-9]*$/,
                                                            message: "Please enter a valid Maximum Users",
                                                        },
                                                    })}
                                                    onKeyUp={() => trigger("maximumUsers")}
                                                />
                                                {errorsForm.maximumUsers && (
                                                    <div className="text-danger mt-1">
                                                        {errorsForm.maximumUsers.message}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Row 3: Description (full width) */}
                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <label className="form-label">Description</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...registerForm("description")}
                                                    onKeyUp={() => trigger("description")}
                                                />
                                                {errorsForm.description && (
                                                    <div className="text-danger mt-1">
                                                        {errorsForm.description.message}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Row 4: Plans Multi-Select (full width) */}
                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <label className="form-label">
                                                    Plans <span className="text-danger">*</span>
                                                </label>
                                                <FormControl fullWidth>
                                                    <Select
                                                        multiple
                                                        value={selectedPlans}
                                                        onChange={(e) => {
                                                            setSelectedPlans(e.target.value);
                                                        }}
                                                        renderValue={(selected) => (
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                                {selected.map((value) => {
                                                                    const plan = plans.find(p => p.id === value);
                                                                    return (
                                                                        <Chip
                                                                            key={value}
                                                                            label={plan?.name || value}
                                                                            size="small"
                                                                        />
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    >
                                                        {plans && plans.map((plan) => (
                                                            <MenuItem key={plan.id} value={plan.id}>
                                                                <Checkbox
                                                                    checked={selectedPlans.includes(plan.id)}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked) {
                                                                            setSelectedPlans([...selectedPlans, plan.id]);
                                                                        } else {
                                                                            setSelectedPlans(selectedPlans.filter(id => id !== plan.id));
                                                                        }
                                                                    }}
                                                                />
                                                                <ListItemText primary={`${plan.name} - ${plan.description}`} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                {selectedPlans.length === 0 && (
                                                    <div className="text-danger mt-2" style={{ fontSize: '14px' }}>Please select at least one plan</div>
                                                )}
                                            </div>
                                        </div>

                                    </ModalBody>

                                    <Modal.Footer>
                                        <div className="py-2 mb-3">
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <button className='btn btn-warning w-md btn-md me-2' type="button" id="AnomalyDetailsWriteYourReason_Modal_AlertSucc_OkayBtn" onClick={handleModalClose} > Cancel </button>
                                                    <button className='btn btn-primary w-md btn-md ' type="submit" id="AnomalyDetailsWriteYourReason_Modal_AlertSucc_OkayBtn" > Save </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Modal.Footer>
                                </form>
                            </Modal>

                        </div> {/* container-fluid */}
                    </div>
                    {/* End Page-content */}
                    <Footer />
                </div>
                {/* end main content*/}

            </div>
            {/* END layout-wrapper */}

            {/* Right bar overlay*/}

        </>
    )

}
